import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const loc = useLocation();
  const nav = useNavigate();

  const linkCls = (path) =>
    `text-xs tracking-[0.28em] uppercase font-mono-ui transition-colors ${
      loc.pathname === path ? "text-white" : "text-neutral-500 hover:text-white"
    }`;

  return (
    <div className="grain min-h-screen bg-black text-white flex flex-col">
      <header className="sticky top-0 z-50 border-b border-white/10 bg-black/70 backdrop-blur-xl">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
          <Link to="/" data-testid="nav-logo" className="font-serif-editorial text-2xl tracking-tighter">
            SurrAIlism<span className="text-neutral-500">.</span>
          </Link>
          <nav className="hidden md:flex items-center gap-10">
            <Link to="/models" className={linkCls("/models")} data-testid="nav-models">Models</Link>
            <Link to="/vote" className={linkCls("/vote")} data-testid="nav-vote">Vote</Link>
            <Link to="/pricing" className={linkCls("/pricing")} data-testid="nav-pricing">Pricing</Link>
            {user && <Link to="/dashboard" className={linkCls("/dashboard")} data-testid="nav-dashboard">Dashboard</Link>}
            {user?.is_admin && <Link to="/admin" className={linkCls("/admin")} data-testid="nav-admin">Admin</Link>}
          </nav>
          <div className="flex items-center gap-4">
            {user ? (
              <>
                <div className="hidden md:flex items-center gap-2 text-xs font-mono-ui">
                  <span className="text-neutral-500">CREDITS</span>
                  <span className="text-white" data-testid="credit-balance">{user.credits}</span>
                </div>
                <button onClick={logout} data-testid="logout-btn" className="btn-ghost !py-2 !px-4">Logout</button>
              </>
            ) : (
              <>
                <button onClick={() => nav("/login")} data-testid="nav-login" className="btn-ghost !py-2 !px-4">Login</button>
                <button onClick={() => nav("/signup")} data-testid="nav-signup" className="btn-white !py-2 !px-4">Join</button>
              </>
            )}
          </div>
        </div>
      </header>

      <main className="flex-1">{children}</main>

      <footer className="border-t border-white/10 mt-32">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16 grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="font-serif-editorial text-3xl mb-4">SurrAIlism.</div>
            <p className="text-neutral-500 text-sm max-w-md leading-relaxed">
              A curated archive of surrealist editorial photography. Blurred until earned. Unlocked with intention.
            </p>
          </div>
          <div>
            <div className="overline mb-4">Navigate</div>
            <ul className="space-y-2 text-sm text-neutral-400">
              <li><Link to="/models" className="hover:text-white">Models</Link></li>
              <li><Link to="/vote" className="hover:text-white">Vote</Link></li>
              <li><Link to="/pricing" className="hover:text-white">Pricing</Link></li>
            </ul>
          </div>
          <div>
            <div className="overline mb-4">Legal</div>
            <ul className="space-y-2 text-sm text-neutral-400">
              <li>Terms</li><li>Privacy</li><li>© 2026</li>
            </ul>
          </div>
        </div>
      </footer>
    </div>
  );
}
